const services = () => {

    $('.service-first-col').find('input:checkbox').change(e => {
        if ($(e.target).is(':checked')) {
            $(e.target).closest('tr').find('input:radio').attr('disabled', 'true');
        } else {
            $(e.target).closest('tr').find('input:radio').removeAttr('disabled');
        }
        
    });

  

};

export {
    services
};
